interface Props {
  [key: string]: any
}

export default function TimesBoldIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 15 16" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M2 14.2288L13 2.22876M2 2.22876L13 14.2288"
        stroke="#7D38D6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.97685"
      />
    </svg>
  )
}
